import { createFileRoute, redirect } from "@tanstack/react-router";

import { InstagramOnboardingPage } from "@/components/Pages/Instagram";
import { INSTAGRAM_BOT_ENABLED } from "@/lib/instagram/constants";

export const Route = createFileRoute("/_guard/shops/instagram")({
  beforeLoad: () => {
    if (!INSTAGRAM_BOT_ENABLED) throw redirect({ to: "/coming-soon" });
  },
  component: InstagramOnboardingPage,
});
